import UserProfile from './profile.enum';

export default class Access {
  id: string;

  username: string;

  profile: UserProfile;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.username = obj.username || '';
    this.profile = obj.profile || UserProfile.USER;
  }
}
